import ReportsOverviewTable from "./ReportsOverviewTable";
import { CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Reports() {
  const { t } = useTranslation();
  const navigate = useNavigate();
    const { tableData, loading, error } = ReportsOverviewTable();
  
    if (loading) {
      return (
        <MDBox p={3}>
          <MDTypography variant="h6" fontWeight="medium" gutterBottom>
            <CircularProgress />
          </MDTypography>
        </MDBox>
      );
    }
  
    if (error) {
      return (
        <MDBox p={3}>
          <MDTypography variant="h6" color="error" gutterBottom>
            {t("trajectories.wizard.reports.error")} {error}
          </MDTypography>
        </MDBox>
      );
    }
      function handleRowClick(row) {
        navigate("/trajectories/result", { state: { rowData: row } });
    }
    return (
      <div className="diagramContainer">
        <MDTypography variant="h6" fontWeight="medium" gutterBottom>
          {t("trajectories.wizard.reports.diagramTitle")}
        </MDTypography>
        <div className="scrollable-100">
          <DataTable
            table={tableData}
                   canSearch
                    onRowClick={(e) => handleRowClick(e)}/>
        </div>
      </div>
    );
  }
  
 
  export default Reports;